<template>
  <section
    class="header header-menu-section"
    :class="toggleclass"
  >
    <page-header-search />
    <div class="menu-container">
      <div class="secondary-region">
        <b-container>
          <b-navbar toggleable="lg">
            <commponent
              :is="elementLogoComponent"
              :logo="logoFile"
            />

            <div class="header-navigation-region">
              <div class="mini-main-navigation">
                <b-collapse
                  id="nav_collapse"
                  is-nav
                >
                  <main-menu menu-style="desktop" />
                </b-collapse>
              </div>

              <div class="user-actions">
                <user-actions :help-active="helpActive" />
              </div>
              <component :is="mobilenav" />
            </div>
          </b-navbar>
        </b-container>
      </div>
    </div>
  </section>
</template>

<script>
import CommonMixin from '../mixins/page-navbar'

export default {
  name: 'page-navbar-0002',
  asyncComponents: ['user-actions'],
  mixins: [
    CommonMixin
  ],
  props: {
    helpActive: {
      default: false,
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      menuHidden: true,
      _cachedHasHeader: false
    }
  },
  computed: {
    logoFile() {
      if (this.menuHidden) {
        return this.pageHasHeader ? 'logo' : 'logo-menu'
      }
      else {
        return 'logo-menu'
      }
    },
    noticebarEnabled() {
      const featureEnabled = this.$store.state.registry.getFeature('noticebar')
      const settings = this.$store.getters['noticebar/settings']
      const settingsEnabled = (settings) ? settings.enabled : false

      return featureEnabled && settingsEnabled
    },
    toggleclass() {
      return (this.menuHidden ? 'menu-closed' : 'menu-opened') + (this.noticebarEnabled ? ' header-menu-section-noticebar' : ' header-menu-section-nonoticebar')
    },
    pageHasHeader() {
      if (!this.$store.state.progressLoaderState) {
        this._cachedHasHeader = this.$store.state.pageSettings.hasHeader
      }
      return this._cachedHasHeader
    },
    mobilenav: function() {
      let version = this.$store.getters['getModuleSetting'](
        'theme',
        'mobile-nav',
        'mobile-menu'
      )
      return `mobile-nav-${version}`
    }
  },
  created() {
    this.$eventHub.$on('hideMobileMenu', this.hideMobileMenu)
    this.$eventHub.$on('showMobileMenu', this.showMobileMenu)
  },
  methods: {
    hideMobileMenu() {
      this.menuHidden = true
    },
    showMobileMenu() {
      this.menuHidden = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

//override placement for the edit node button

.header.header-menu-section {
 ::v-deep .edit-node {
    right: -3em;
    position: absolute;
  }
}

.header.header-menu-section {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 110;
  @include transition(background-color 0.3s);

 ::v-deep .navigation.nav .nav-item {
    .nav-link {
      font-family: var(--main-header-secondary-font);
      font-weight: var(--main-header-secondary-font-weight);
      color: var(--main-site-header-nav-link);
      @include transition(color 0.3s);
      font-size: var(--main-header-secondary-font-size);

      padding: 0em;
    }
  }
 ::v-deep .navbar-nav {
    display: flex;
    flex-direction: row;
  }
 ::v-deep .nav-label {
    display: none;
  }
 ::v-deep .dropdown-menu {
    border: 0px;
    background-color: var(--main-site-header-dropdown-background-color);

    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.25);
    &:before {
      width: 1.5em;
      height: 0.75rem;
      background: white;
      -webkit-clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0em;
      z-index: 1;
      transform: translate(0, 0em);
      transition: translate, 0.3s;
      content: " ";
      top: -0.75rem;
      right: 1em;
      margin-left: auto;
    }
    .dropdown-item {
      padding: 0.25rem 1rem;
      color: var(--main-site-header-dropdown-link-color);
      @include hover-focus {
        color: var(--main-site-header-dropdown-hover-link-color);
        background-color: var(
          --main-site-header-dropdown-hover-background-color
        );
      }
    }
  }
 ::v-deep .cart-element {
    .cart-count {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
 ::v-deep .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .icon {
      width: var(--main-site-header-icon-size);
      height: var(--main-site-header-icon-size);
      fill: var(--header-menu-button-text-color);
    }
  }
 ::v-deep .header-navigation-region {
    display: flex;
    align-items: center;
    margin-left: auto;

    .mini-main-navigation {
      ul ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      .navigation {
        &.nav {
          > ul,
          > li {
            margin-left: 1.5em;
          }
        }
      }
      .navigation {
        &.nav {
          .dropdown-menu {
            background: var(--main-header-secondary-region-dropdown-background);
            box-shadow: var(
              --main-header-secondary-region-dropdown-background-box-shadow
            );
            margin-top: 1em;
            &:before {
              background: var(
                --main-header-secondary-region-dropdown-background
              );
              top: -0.7rem;
            }
            .dropdown-item,
            .nav-link {
              padding: 0.5em 1em;
              font-size: 1em;
              color: var(--main-header-secondary-region-dropdown-text-color);
              @include hover-focus {
                background: var(
                  --main-header-secondary-region-dropdown-background-highlight-color
                );
              }
              &.router-link-exact-active {
                background: var(
                  --main-header-secondary-region-dropdown-text-color
                );
                color: var(--main-header-secondary-region-dropdown-background);
              }
            }
          }
        }
      }
    }
   ::v-deep .header-menu-button {
      margin-left: 0.25rem;
      @include media-breakpoint-up(md) {
        margin-left: 0.5rem;
      }
    }
   ::v-deep .user-actions {
      .nav-item {
        margin-left: 0.25rem;
        @include media-breakpoint-up(md) {
          margin-left: 0.5rem;
        }
      }
      .nav-link {
        padding: 0;
      }
      .btn.btn-link {
        padding: 0;
        margin: 0;
      }
    }
  }
}

.header.header-menu-section-nonoticebar {
  top: 0;
}
.header.header-menu-section-noticebar {
  top: 60px;
}

.menu-container {
  width: 100%;
}

.header.header-menu-section {
  display: flex;
  background: var(--main-site-header-background-color);
  height: var(--main-site-header-height);
  width: 100%;
  align-items: center;
  padding: 0.5em 0;
  @include media-breakpoint-up(md) {
    padding: 1em 0;
  }
  .navbar-brand {
    padding: 0em;
  }

  .navbar {
    padding: 0em;
  }
}

.header-menu-section {
  .secondary {
    width: 100%;
    .nav-item {
      .nav-link {
        color: var(--main-site-header-nav-link);
      }
      margin-right: 0.5em;
      @include media-breakpoint-up(lg) {
        margin-right: 1em;
      }
    }
  }
}
</style>
